module.exports = __webpack_public_path__ + "static/media/Iso-blanco.13384fd8.svg";